export enum LinuxServiceSubState {
    Dead = 'dead',
    Condition = 'condition',
    StartPre = 'start-pre',
    Start = 'start',
    StartPost = 'start-post',
    Running = 'running',
    Exited = 'exited',
    Reload = 'reload',
    Stop = 'stop',
    StopWatchdog = 'stop-watchdog',
    StopSigterm = 'stop-sigterm',
    StopSigkill = 'stop-sigkill',
    StopPost = 'stop-post',
    FinalWatchdog = 'final-watchdog',
    FinalSigterm = 'final-sigterm',
    FinalSigkill = 'final-sigkill',
    Failed = 'failed',
    AutoRestart = 'auto-restart',
    Cleaning = 'cleaning',
}
